import React from 'react'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Button from 'react-bootstrap/Button'
import Header from './Header'
import Container from 'react-bootstrap/Container'
import Footer from './Footer'
import ItemRow from './ItemRow'
import { getImage } from '../managers/ImageHelper'
import UserCellView from './UserCellView'
import EmailSubscribeForm from './EmailSubscribeForm'
import { getSelectorsByUserAgent } from 'react-device-detect'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import UtilsManager from '../managers/UtilsManager'
import Constants from '../components/Constants'
import Modal from 'react-bootstrap/Modal';
import OverlayDiv from '../components/OverlayDiv'
import ETAEventCell from '../components/ETAEventCell'
import Nav from 'react-bootstrap/Nav'
import EventAPI from '../api/EventAPI'
import moment from 'moment'
import DownloadPlug from '../components/DownloadPlug'
import MetricsManager from '../managers/MetricsManager'
import { canoc } from '../managers/Utils'
import SectionRow from '../components/SectionRow'

const jumbotronStyle = {
	boxShadow: `inset 0 0 0 2000px rgba(0,0,0,0.3)`,
	height: '560px', /* You must set a specified height */
	backgroundSize: 'cover',
	backgroundPosition: 'center',
	display: 'flex',
	flexDirection: 'column',
	borderRadius: 0,
	backgroundImage: `url('/static/new_eta_header.jpg')`,
}

const divStyle = {
	boxShadow: `inset 0 0 0 2000px rgba(0,0,0,0.3)`,
	height: '300px', /* You must set a specified height */
	backgroundSize: 'cover',
	backgroundPosition: 'center',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	backgroundImage: `url('/static/background.jpg')`,
}


const ROW_ITEM_COUNT = 4;

const fontColor = 'rgb(118, 118, 118)'
const otherFontColor = 'rgb(72, 72, 72)'

export default class GenericHomeView extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			allZones: null,
			zone: this.props.zone,
			selectedSlug: '',
			coordinates: null,
			events: null,
			currZoneHover: false,
			zonePickerActive: false,
			selectedTab: 'thisWeek',
			tabEvents: []
		}
		this.deviceInfo = getSelectorsByUserAgent(props.userAgent);


		this.exploreWithUsItems = [
			{ title: "Host your next event with our ticketing system", link: "/create", image: "https://gameplan-image-urls.s3.us-east-2.amazonaws.com/frame1.png" },
			{ title: "Submit your event", link: "/submit", image: "/static/Olive_Leaves.png" },
			{ title: "Check out our blog", link: "https://medium.com/eta-hq", image: "https://gameplan-image-urls.s3.us-east-2.amazonaws.com/frame2.png" },
			{ title: "Follow us on instagram", link: "https://www.instagram.com/eta_hq", image: "https://gameplan-image-urls.s3.us-east-2.amazonaws.com/frame3.png" }
		];

		this.eventTab = [
			{ id: 'thisWeek', name: 'THIS WEEK' },
			{ id: 'today', name: 'TODAY' },
			{ id: 'free', name: 'FREE' },
			{ id: 'all', name: 'ALL' },
		]

		this.eventApi = new EventAPI(props.auth);
		this.utilsManager = new UtilsManager();
		this.metricsManager = new MetricsManager();
	}

	async componentDidMount() {
		this.handleGetMoreEventTab(this.state.selectedTab);
	}

	handleCitySelect(city) {
		const zone = this.state.allZones.find(function (x) {
			return x.name == city
		})

		this.setState({ selectedSlug: zone.slug })
	}

	handleCitySubmit(city) {
		this.metricsManager.logEvent("click", { label: "city_select", source: "front_page_section", city: city })
		const url = "/city/" + city;
		window.location.href = url;
	}

	getCuratorsView() {

		return (
			<div>
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<div>
						<div style={{ textAlign: 'center', marginBottom: 20 }}>
							<h2>Meet your curators</h2>
							<p style={{ color: 'gray' }}>Keeping you connected to amazing experiences for the culture.</p>
						</div>
						<div style={{ display: 'flex', justifyContent: 'center' }}>
							{this.props.curators.map((item, index) =>
								<UserCellView
									image_url={item.profile_image}
									username={item.username}
									handleNameClick={(name) => this.props.handleCuratorNameClick(name)}
								/>
							)
							}
						</div>
					</div>

				</div>
			</div>
		)
	}

	getEventTicketingPlug() {
		return (<div style={{ marginBottom: 300 }}>
			<h2>Event ticketing that elevates</h2>
			<p> We help you reach your target audience, sell tickets faster and grow.</p>
		</div>)
	}

	handleClickRSVP(id) {
		this.metricsManager.logEvent("click", { label: "pick_of_the_week", source: "front_page" })
	}

	getCurrentZoneColor() {
		if (this.state.currZoneHover === true) {
			return "gray"
		} else {
			return null;
		}
	}

	handleGetMoreEventTab = async (selectedKey) => {
		this.setState({ selectedTab: selectedKey, tabEvents: [] });
		const today = new Date();
		const day = today.getDay();
		let startDate = new Date();
		let endDate = new Date();
		const myData = {};
		switch (selectedKey) {
			case 'all':
				const eventResult = await this.eventApi.getUpcomingEvents('default', {
					limit: 20,
				});
				if (eventResult && eventResult.code !== -1 && eventResult.length > 0) {
					this.setState({ tabEvents: eventResult });
				}
				break;
			case 'thisWeek':
				startDate.setDate(today.getDate() - day);
				endDate.setDate(today.getDate() - day + 6);

				const eventResultWeek = await this.eventApi.getUpcomingEvents(null, {
					limit: 20,
					start: moment(startDate).format('YYYY-MM-DD'),
					end: moment(endDate).format('YYYY-MM-DD'),
				});

				if (
					eventResultWeek &&
					eventResultWeek.code !== -1 &&
					eventResultWeek.length > 0
				) {
					this.setState({ tabEvents: eventResultWeek });
				}
				break;
			case 'free':
				const eventResultFree = await this.eventApi.getUpcomingEvents('default', {
					limit: 20,
					cost: 0
				});
				if (eventResultFree && eventResultFree.code !== -1 && eventResultFree.length > 0) {
					this.setState({ tabEvents: eventResultFree });
				}
				break;
			case 'today':
				startDate.setDate(today.getDate() - day);
				endDate.setDate(today.getDate() - day + 1);
				const eventResultToday = await this.eventApi.getUpcomingEvents('default', {
					limit: 20,
					start: moment(startDate).format('YYYY-MM-DD'),
					end: moment(endDate).format('YYYY-MM-DD'),
				});

				if (
					eventResultToday &&
					eventResultToday.code !== -1 &&
					eventResultToday.length > 0
				) {
					this.setState({ tabEvents: eventResultToday });
				}
				break;
			default:
				break;
		}
	};

	renderEventsTab = () => {
		const headerStyle = {
			marginBottom: '20px',
			fontSize: '2.2em',
			fontWeight: '400',
		};
		return (
			<div>
				<h2 style={headerStyle}>More Events</h2>
				<Nav
					style={{ marginTop: '20px' }}
					activeKey={this.state.selectedTab}
					onSelect={(selectedKey) => this.handleGetMoreEventTab(selectedKey)}
				>
					{this.eventTab.map((data, index) => {
						return (
							<Nav.Item key={index}>
								<Nav.Link
									style={{
										textDecorationColor:
											this.state.selectedTab === data.id
												? Constants.etaPrimaryColor
												: 'transparent',
										textDecorationLine: 'underline',
										color:
											this.state.selectedTab === data.id ? 'black' : '#8E8E93',
										fontSize: '13px',
										padding: '0px 20px 0px 0px',
										lineHeight: '18px',
										textUnderlinePosition: 'under',
										textUnderlineOffset: 'auto',
									}}
									eventKey={data.id}
								>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						);
					})}
				</Nav>
				<div style={{ marginTop: '20px', marginBottom: '20px' }}>
					<Row>
						{this.state.tabEvents.length > 0 ? (
							<>
								{this.state.tabEvents.map((event) => {
									return (
										<ETAEventCell item={event} />
									);
								})}
							</>
						) : (
							<div style={{ marginLeft: '15px' }}>No events avilable</div>
						)}
					</Row>
					<Row style={{ justifyContent: 'center', alignItems: 'center' }}>
						<div
							style={{
								backgroundColor: '#FFFFFF',
								border: '1px solid #000000',
								// boxSizing: 'border-box',
								borderRadius: '40px',
							}}
						>
							<p
								style={{
									textAlign: 'center',
									fontWeight: 'normal',
									fontSize: '18px',
									textAlign: 'center',
									letterSpacing: '0.75px',
									color: '#000000',
									marginBottom: '0',
									padding: '10px 15px',
								}}
							>
								View More
							</p>
						</div>
					</Row>
				</div>
			</div>
		);
	};

	getZoneTitle() {
		const headerStyle = { fontSize: '2.2em', fontWeight: '400' }
		if (this.props.zone.slug === "default") {
			headerStyle.marginBottom = "20px";
			return <h2 style={headerStyle}>Trending</h2>
		} else {
			headerStyle.marginBottom = "2px"
			return <div style={{ marginBottom: '20px' }}>
				<div style={{ alignItems: 'flex-end', display: 'flex', paddingBottom: '5px' }}>
					<h2 style={headerStyle}>What's happening in <u
						style={{
							textDecorationColor: Constants.etaPrimaryColor, backgroundColor: this.getCurrentZoneColor(),
							cursor: 'pointer', textUnderlineOffset: '8px'
						}}
						onMouseEnter={() => this.setState({ currZoneHover: true })}
						onMouseLeave={() => this.setState({ currZoneHover: false })}
						onClick={() => this.setState({ zonePickerActive: true })}
					>{this.props.zone.name}</u></h2>
				</div>
			</div>
		}
	}

	getSectionRender(item) {
		if (item.identifier && item.identifier.includes("recruit_curator")) {
			return <OverlayDiv imageUrl={item.items[0].image} width="100%" style={{ padding: '50px', height: '300px', marginBottom: '50px', marginRight: '10px', borderRadius: '20px' }}>
				<h1 style={{ color: 'white' }}>{item.items[0].title}</h1>
				<p style={{ color: 'white' }}>{item.items[0].subtitle_one}</p>
				{item.items[0].subtitle_two && <p style={{ color: 'white' }}>{item.items[0].subtitle_two}</p>}

			</OverlayDiv>
		}
		return <ItemRow
			items={item.items}
			title={item.title}
			getItemRender={(rowItem) => <ETAEventCell
				style={{ width: this.deviceInfo.isMobile ? '300px' : 'calc(25% - 20px)', marginRight: '20px' }}
				item={this.getItemDataProps(rowItem, item.item_kind, "front_page")}
				showCost={item.item_kind !== "place"}
				onClick={() => null}

			/>}
			subtitle={item.description}
			rowItemCount={ROW_ITEM_COUNT}
			onEventClick={(eventId) => null}
			onVideoClick={(vid_url, event_id) => this.props.onVideoClick(vid_url, event_id)}
		/>
	}

	getItemDataProps(item, kind, aff) {
		if (kind === "place") {
			return { title: item.name, subtitle: item.address + " - " + item.hours, cost: item.cost, image_url: item.image, tags: item.tags, link: item.link }
		}
		else if (kind === "raw_item") {
			return { title: item.title, subtitle: item.subtitle_one, cost: null, image_url: item.image, tags: item.tags, link: item.link + `?aff=${aff}` }
		} else {
			return { title: item.title, subtitle: moment(item.start_date).format('ddd MMM Do, h:mm a'), cost: item.cost, image_url: item.image_url, tags: item.tags, link: `/event/${canoc(item.title, item.id)}?aff=${aff}` }
		}
	}

	render() {
		return (
			<div>
				<Header scrollColorChange={true} showEventSearchBar={true} useContainer containerStyle={{ minWidth: '80%' }} noHead />
				<Jumbotron style={jumbotronStyle}>
					<Container style={{ display: 'flex', alignItems: 'center', height: '100%', minWidth: '80%' }}>
						<div style={{ width: !this.deviceInfo.isMobile ? '45%' : '100%' }}>
							<h1 style={{ color: 'white', fontSize: '3em' }}>The Culture Is Here</h1>
							<p style={{ color: 'white', fontSize: '1.2em', marginBottom: '30px' }}
							>From turn ups, to art shows discover the best things happening for the culture.</p>
							<Row>
								<Button size="lg" variant="info" style={{ marginRight: '20px', borderRadius: '20px' }} onClick={() => {
									this.metricsManager.logEvent("click", { label: "download", source: "home_page_hero" });
									window.location.href = "/downloads"
								}}>Download
								</Button>
								<Button size="lg" variant="light" style={{ borderRadius: '20px' }} onClick={() => {
									this.metricsManager.logEvent("click", { lable: "browse_events", source: "home_page_hero" });
									window.scrollTo(0, 400);
								}}>Browse events
								</Button>
							</Row>
							<p style={{color: 'white', marginTop: 20}}>Join over <span style={{textDecoration: 'underline'}}>10k+ people</span> who've been plugged in for free</p>
						</div>
					</Container>
				</Jumbotron>

				<Container style={{ marginBottom: 20, minWidth: '80%', paddingRight: '0px' }}>

					{this.props.zone && <div>
						<ItemRow
							getTitle={() => this.getZoneTitle()}
							getItemRender={(item) => <ETAEventCell
								style={{ width: this.deviceInfo.isMobile ? '300px' : 'calc(25% - 20px)', marginRight: '20px' }}
								item={this.getItemDataProps(item, "event", "front_page")}
								onClick={() => null}
							/>}
							rowItemCount={ROW_ITEM_COUNT}
							subtitle={null}
							items={this.props.events}
							onEventClick={(eventId) => null}
							onVideoClick={(vid_url, event_id) => this.props.onVideoClick(vid_url, event_id)}
							allowHorizontalOverflow={true}

						/>
					</div>}


					{this.props.curators && this.props.curators.length > 0 && <div style={{ marginBottom: 30, marginTop: 100 }}>
						{this.getCuratorsView()}
					</div>}

					<div>
						{this.props.sections && this.props.sections.map((item, index) =>
							<SectionRow item={item}/>
						)}
					</div>

				</Container>


				{this.props.topEvent && <div style={{ backgroundColor: 'black', widht: '100%', marginTop: '100px' }}>
					<Container style={{ paddingRight: '0px', minWidth: '80%' }}>
						<Row>
							<Col style={{ display: 'flex', justifyContent: 'center', minHeight: '100%' }}>
								<div>
									<h2 style={{ color: 'white', marginTop: '50px', fontSize: '54px' }}>Pick of the week</h2>
									<div style={{ marginTop: '40px', marginBottom: '20px' }}>
										<p style={{ color: '#FFFFFF', fontSize: '1.5em' }}>
											<strong>{this.props.topEvent.title}</strong>
										</p>
										<p style={{ color: '#FFFFFF' }}>{this.utilsManager.getTruncatedText(this.props.topEvent.description, 100)} </p>
										<div style={{ marginTop: '40px' }}>
											<a href={"event/" + this.props.topEvent.id + "?aff=front_page"}>
												<Button onClick={() => this.handleClickRSVP(this.props.topEvent.id)} style={{ borderRadius: '20px' }} variant="light">
													RSVP
												</Button>
											</a>
										</div>
									</div>
								</div>
							</Col>
							<Col md style={{ minHeight: '200px' }}>
								<div style={{
									backgroundImage: `url(${this.props.topEvent.image_url})`,
									backgroundPosition: 'center',
									backgroundSize: 'cover',
									height: '100%',
									width: '100%'
								}}>
								</div>
							</Col>

						</Row>
					</Container>
				</div>}

				<Container style={{ marginTop: '100px', paddingRight: '0px' }}>
					<ItemRow
						items={this.props.allZones}
						title={"Our cities"}
						subtitle={"Cities where we have local curators on the ground helping you find the move."}
						getItemRender={(item) =>
							<div style={{ marginRight: 20, cursor: 'pointer' }}>
								<a href={`/city/${item.slug}`}>
									<div style={{
										backgroundImage: `url(${getImage(item.image)})`, width: '200px', height: '200px', backgroundSize: 'cover',
										backgroundPosition: 'center'
									}}
										onClick={() => this.handleCitySubmit(item.slug)}></div>
								</a>
								<a href={`/city/${item.slug}`}>
									<p style={{ marginTop: 10, marginBottom: 0, color: otherFontColor }}><strong>{item.name}</strong></p>
								</a>
							</div>
						}
						rowItemCount={ROW_ITEM_COUNT}
					/>



					<div style={{ marginTop: 100 }}>
						<ItemRow
							items={this.exploreWithUsItems}
							getTitle={() => <h2 style={{ marginBottom: '25px', fontSize: '2.2em', fontWeight: '400' }}>Explore with us</h2>}
							getItemRender={(item) =>
								<div>
									<div style={{ marginRight: '10px', cursor: 'pointer', width: '300px' }}
										onClick={() => {
											this.metricsManager.logEvent("click", { label: "explore_with_us", source: item.title })
											window.location.href = item.link
										}
										}>
										<div style={{ height: '200px', width: '100%', backgroundImage: `url(${item.image})`, backgroundPosition: 'center' }}></div>
										<p style={{ marginTop: '10px' }}><strong>{item.title}</strong></p>
									</div>
								</div>}
							rowItemCount={4}
							subtitle={null}
							allowHorizontalOverflow={true}
						/>
					</div>


					<div style={{ paddingRight: '0px' }}>
						<div style={{ marginBottom: '80px' }}>
							<DownloadPlug includeImage style={{ padding: '2px', margin: '2px' }} id="download_homepage"></DownloadPlug>
						</div>
						<div>
							<h3 style={{ textAlign: 'center' }}>As seen in</h3>
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
								<div style={{ marginRight: '20px' }}>
									<img src="/static/afrotech_logo.svg" style={{ width: '140px', textAlign: 'center' }} />
							</div>
								<div>
									<img src="/static/voyagela_logo.png" style={{ width: '140px', textAlign: 'center' }}></img>
								</div>
							</div>
						</div>
					</div>

					<Modal show={this.state.zonePickerActive} onHide={() => this.setState({ zonePickerActive: false })}>
						<Modal.Header closeButton>
							<Modal.Title>Select city</Modal.Title>
						</Modal.Header>
						<div style={{ height: '100%' }}>
							<div>
								{this.props.allZones && this.props.allZones.map((item, index) => <OverlayDiv
									height="100px"
									onClick={() => this.handleCitySubmit(item.slug)}
									imageUrl={item.image}>
									<div style={{ height: '100%', cursor: 'pointer', justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
										<p style={{ color: 'white' }}>{item.name}</p>
									</div>
								</OverlayDiv>)}
							</div>
						</div>
					</Modal>

					{/* <div>{this.renderEventsTab()}</div> */}

					<div style={{ marginTop: 80, marginBottom: 80 }}>
						<EmailSubscribeForm
							title="Join the tribe and stay updated"
							includeCity
							body="We'll let you know about special events, popups and more in your city"
						/>
					</div>

					<div style={{ display: "flex", justifyContent: "center", marginBottom: "3%" }}>
						<a href="/search">
							<Button variant="outline-dark" size="lg" style={{ borderRadius: '25px' }} onClick={() => this.metricsManager.logEvent("click", { label: "view_more_events", source: "front-page" })}>
								View more events</Button>
						</a>
					</div>

				</Container>
				<Footer />
				<style jsx global>{`
				.h1, .h2, .h3, .h4, h1, h2, h3, h4{ 
					font-family: 'Nerko One', sans-serif !important;
					font-stye: normal;
					font-weight: normal !important;
					letter-spacing: 1px !important;
				}`
				}</style>
			</div>
		)
	}
}